import { useMutation } from "@apollo/client";
import { ADD_ORGANIZATION_MUTATION } from "admin-app/services/mutations";
import { Button, Form, Input, message, Modal } from "antd";
import { useForm } from "antd/lib/form/Form";
import { SidepanelStyles } from "constants/index";
import { useState } from "react";

function AddOrganizationForm({
  onClose,
  open
}: {
  onClose: () => void;
  open: boolean;
}) {
  const [form] = useForm();

  const [loading, setLoader] = useState(false);
  const [addOrganizationMutation] = useMutation(ADD_ORGANIZATION_MUTATION);

  const onFinish = async (value: any) => {
    console.log(value);
    setLoader(true);
    const res = await addOrganizationMutation({ variables: { object: value } });
    if (res.data) {
      message.success("Added successfully.");
      if (onClose) onClose();
    }
    if (res.errors) {
      message.error(res.errors[0].message);
    }
    setLoader(false);
  };
  return (
    <Modal
      className="custom-drawer"
      title="Add Organization"
      width={420}
      style={SidepanelStyles.style}
      footer={
        <div className="w-full flex justify-end">
          <Button
            form="AddOrganizationForm"
            type="primary"
            loading={loading}
            htmlType="submit"
            className="px-5"
            data-testid="btn-addorganization-modal-create"
          >
            Create
          </Button>
        </div>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
    >
      <Form
        id="AddOrganizationForm"
        onFinish={onFinish}
        form={form}
        labelCol={{ span: 50 }}
        wrapperCol={{ span: 30 }}
        scrollToFirstError
        layout="vertical"
        className="p-2"
        disabled={loading}
      >
        <Form.Item
          name="name"
          label="Organization Name"
          rules={[
            { required: true, message: "Please enter organization name." }
          ]}
          required
        >
          <Input placeholder="Enter Organization Name" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default AddOrganizationForm;
